<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北侧进气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="1#除湿机组(镇宁侧)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/left"></router-link>
          </el-tooltip>
          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("1#除湿机组(镇宁侧)", "", "", runningDehumidifierLeft, malfunctionDehumidifierLeft) }}
              </div>
              <div :class="errorDehumidifierLeft" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">1#除湿机组(镇宁侧) <span :class="runningClassLeft" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-middle" content="3#除湿机组(跨中)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/middle"></router-link>
          </el-tooltip>
          <div class="stati sta-middle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("3#除湿机组(跨中)", "", "", runningDehumidifierMiddle, malfunctionDehumidifierMiddle) }}
              </div>
              <div :class="errorDehumidifierMiddle" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">3#除湿机组(跨中) <span :class="runningClassMiddle" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#除湿机组(胜境关侧)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/right"></router-link>
          </el-tooltip>
          <div class="stati sta-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("2#除湿机组(胜境关侧)", "", "", runningDehumidifierRight, malfunctionDehumidifierRight) }}
              </div>
              <div :class="errorDehumidifierRight" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">2#除湿机组(胜境关侧) <span :class="runningClassRight" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor2 sensor-anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorLeftNorth, humidityAllowedMaxAnchorLeftNorth) }}
              </div>
              <div :class="errorAnchorLeftNorth" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁北侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorLeftNorth | toFixed }}% {{ temperatureAnchorLeftNorth | toFixed }}°C
                    {{ absHumidityAnchorLeftNorth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorRightNorth, humidityAllowedMaxAnchorRightNorth) }}
              </div>
              <div :class="errorAnchorRightNorth" class="state-info top-right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关北侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorRightNorth | toFixed }}% {{ temperatureAnchorRightNorth | toFixed }}°C
                    {{ absHumidityAnchorRightNorth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor2 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E5, humidityAllowedMax1E5) }}
              </div>
              <div :class="error1E5" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E5传感器</p>
                <p>
                  <span>{{ humidity1E5 | toFixed }}% {{ temperature1E5 | toFixed }}°C {{ absHumidity1E5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E5 | toFixed }}Pa {{ flow1E5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W5, humidityAllowedMax1W5) }}
              </div>
              <div :class="error1W5" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W5传感器</p>
                <p>
                  <span>{{ humidity1W5 | toFixed }}% {{ temperature1W5 | toFixed }}°C {{ absHumidity1W5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W5 | toFixed }}Pa {{ flow1W5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-left-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3E5, humidityAllowedMax3E5) }}
              </div>
              <div :class="error3E5" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3E5传感器</p>
                <p>
                  <span>{{ humidity3E5 | toFixed }}% {{ temperature3E5 | toFixed }}°C {{ absHumidity3E5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3E5 | toFixed }}Pa {{ flow3E5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-left-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3E1, humidityAllowedMax3E1) }}
              </div>
              <div :class="error3E1" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3E1传感器</p>
                <p>
                  <span>{{ humidity3E1 | toFixed }}% {{ temperature3E1 | toFixed }}°C {{ absHumidity3E1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3E1 | toFixed }}Pa {{ flow3E1 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-right-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3W1, humidityAllowedMax3W1) }}
              </div>
              <div :class="error3W1" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3W1传感器</p>
                <p>
                  <span>{{ humidity3W1 | toFixed }}% {{ temperature3W1 | toFixed }}°C {{ absHumidity3W1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3W1 | toFixed }}Pa {{ flow3W1 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-right-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3W5, humidityAllowedMax3W5) }}
              </div>
              <div :class="error3W5" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3W5传感器</p>
                <p>
                  <span>{{ humidity3W5 | toFixed }}% {{ temperature3W5 | toFixed }}°C {{ absHumidity3W5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3W5 | toFixed }}Pa {{ flow3W5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-middle-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E5, humidityAllowedMax2E5) }}
              </div>
              <div :class="error2E5" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E5传感器</p>
                <p>
                  <span>{{ humidity2E5 | toFixed }}% {{ temperature2E5 | toFixed }}°C {{ absHumidity2E5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E5 | toFixed }}Pa {{ flow2E5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor2 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W5, humidityAllowedMax2W5) }}
              </div>
              <div :class="error2W5" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W5传感器</p>
                <p>
                  <span>{{ humidity2W5 | toFixed }}% {{ temperature2W5 | toFixed }}°C {{ absHumidity2W5 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W5 | toFixed }}Pa {{ flow2W5 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北侧排气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <!-- <div class="clip sensor2 sensor-saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("镇宁北侧鞍室1", humidityTooltipErrorSaddleLeftNorth1, humidityAllowedMaxSaddleLeftNorth1) }}
                <br />
                {{ assembleTooltip_sensor("镇宁北侧鞍室2", humidityTooltipErrorSaddleLeftNorth2, humidityAllowedMaxSaddleLeftNorth2) }}
                <br />
                {{ assembleTooltip_sensor("镇宁北侧鞍室3", humidityTooltipErrorSaddleLeftNorth3, humidityAllowedMaxSaddleLeftNorth3) }}
              </div>
              <div :class="errorSaddleLeftNorth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁北侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleLeftNorth1 | toFixed }}% {{ temperatureSaddleLeftNorth1 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftNorth2 | toFixed }}% {{ temperatureSaddleLeftNorth2 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftNorth3 | toFixed }}% {{ temperatureSaddleLeftNorth3 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("胜境关北侧鞍室1", humidityTooltipErrorSaddleRightNorth1, humidityAllowedMaxSaddleRightNorth1) }}
                <br />
                {{ assembleTooltip_sensor("胜境关北侧鞍室2", humidityTooltipErrorSaddleRightNorth2, humidityAllowedMaxSaddleRightNorth2) }}
                <br />
                {{ assembleTooltip_sensor("胜境关北侧鞍室3", humidityTooltipErrorSaddleRightNorth3, humidityAllowedMaxSaddleRightNorth3) }}
              </div>
              <div :class="errorSaddleRightNorth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关北侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleRightNorth1 | toFixed }}% {{ temperatureSaddleRightNorth1 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightNorth2 | toFixed }}% {{ temperatureSaddleRightNorth2 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightNorth3 | toFixed }}% {{ temperatureSaddleRightNorth3 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E1, humidityAllowedMax1E1) }}
              </div>
              <div :class="error1E1" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E1传感器</p>
                <p>
                  <span>{{ humidity1E1 | toFixed }}% {{ temperature1E1 | toFixed }}°C {{ absHumidity1E1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E1 | toFixed }}Pa {{ flow1E1 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E9, humidityAllowedMax1E9) }}
              </div>
              <div :class="error1E9" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E9传感器</p>
                <p>
                  <span>{{ humidity1E9 | toFixed }}% {{ temperature1E9 | toFixed }}°C {{ absHumidity1E9 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E9 | toFixed }}Pa {{ flow1E9 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W9, humidityAllowedMax1W9) }}
              </div>
              <div :class="error1W9" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W9传感器</p>
                <p>
                  <span>{{ humidity1W9 | toFixed }}% {{ temperature1W9 | toFixed }}°C {{ absHumidity1W9 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W9 | toFixed }}Pa {{ flow1W9 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W1, humidityAllowedMax1W1) }}
              </div>
              <div :class="error1W1" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W1传感器</p>
                <p>
                  <span>{{ humidity1W1 | toFixed }}% {{ temperature1W1 | toFixed }}°C {{ absHumidity1W1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W1 | toFixed }}Pa {{ flow1W1 | toFixed }}m/s</span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-left-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3E3, humidityAllowedMax3E3) }}
              </div>
              <div :class="error3E3" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3E3传感器</p>
                <p>
                  <span>{{ humidity3E3 | toFixed }}% {{ temperature3E3 | toFixed }}°C {{ absHumidity3E3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3E3 | toFixed }}Pa {{ flow3E3 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-right-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3W3, humidityAllowedMax3W3) }}
              </div>
              <div :class="error3W3" class="state-info top-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3W3传感器</p>
                <p>
                  <span>{{ humidity3W3 | toFixed }}% {{ temperature3W3 | toFixed }}°C {{ absHumidity3W3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3W3 | toFixed }}Pa {{ flow3W3 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E1, humidityAllowedMax2E1) }}
              </div>
              <div :class="error2E1" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E1传感器</p>
                <p>
                  <span>{{ humidity2E1 | toFixed }}% {{ temperature2E1 | toFixed }}°C {{ absHumidity2E1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E1 | toFixed }}Pa {{ flow2E1 | toFixed }}m/s</span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-middle-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E9, humidityAllowedMax2E9) }}
              </div>
              <div :class="error2E9" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E9传感器</p>
                <p>
                  <span>{{ humidity2E9 | toFixed }}% {{ temperature2E9 | toFixed }}°C {{ absHumidity2E9 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E9 | toFixed }}Pa {{ flow2E9 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W9, humidityAllowedMax2W9) }}
              </div>
              <div :class="error2W9" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W9传感器</p>
                <p>
                  <span>{{ humidity2W9 | toFixed }}% {{ temperature2W9 | toFixed }}°C {{ absHumidity2W9 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W9 | toFixed }}Pa {{ flow2W9 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W1, humidityAllowedMax2W1) }}
              </div>
              <div :class="error2W1" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W1传感器</p>
                <p>
                  <span>{{ humidity2W1 | toFixed }}% {{ temperature2W1 | toFixed }}°C {{ absHumidity2W1 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W1 | toFixed }}Pa {{ flow2W1 | toFixed }}m/s </span>
                </p>
              </div>
            </el-tooltip>
            <div class="sensor-clamp-triangle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature, pressure, flow, volume
      humidityDehumidifierLeft: "--",
      humidityDehumidifierMiddle: "--",
      humidityDehumidifierRight: "--",
      humidityAnchorLeftNorth: "--",
      humidityAnchorLeftSouth: "--",
      humidityAnchorRightNorth: "--",
      humidityAnchorRightSouth: "--",
      humiditySaddleLeftNorth1: "--",
      humiditySaddleLeftNorth2: "--",
      humiditySaddleLeftNorth3: "--",
      humiditySaddleLeftSouth1: "--",
      humiditySaddleLeftSouth2: "--",
      humiditySaddleLeftSouth3: "--",
      humiditySaddleRightNorth1: "--",
      humiditySaddleRightNorth2: "--",
      humiditySaddleRightNorth3: "--",
      humiditySaddleRightSouth1: "--",
      humiditySaddleRightSouth2: "--",
      humiditySaddleRightSouth3: "--",

      humidity1E0: "--",
      humidity1E1: "--",
      humidity1E4: "--",
      humidity1E5: "--",
      humidity1E8: "--",
      humidity1E9: "--",
      humidity1W0: "--",
      humidity1W1: "--",
      humidity1W4: "--",
      humidity1W5: "--",
      humidity1W8: "--",
      humidity1W9: "--",
      humidity2E0: "--",
      humidity2E1: "--",
      humidity2E4: "--",
      humidity2E5: "--",
      humidity2E8: "--",
      humidity2E9: "--",
      humidity2W0: "--",
      humidity2W1: "--",
      humidity2W4: "--",
      humidity2W5: "--",
      humidity2W8: "--",
      humidity2W9: "--",
      humidity3E1: "--",
      humidity3E3: "--",
      humidity3E5: "--",
      humidity3W1: "--",
      humidity3W3: "--",
      humidity3W5: "--",
      humidity3E0: "--",
      humidity3E2: "--",
      humidity3E4: "--",
      humidity3W0: "--",
      humidity3W2: "--",
      humidity3W4: "--",

      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierMiddle: "--",
      temperatureDehumidifierRight: "--",
      temperatureAnchorLeftNorth: "--",
      temperatureAnchorLeftSouth: "--",
      temperatureAnchorRightNorth: "--",
      temperatureAnchorRightSouth: "--",
      temperatureSaddleLeftNorth1: "--",
      temperatureSaddleLeftNorth2: "--",
      temperatureSaddleLeftNorth3: "--",
      temperatureSaddleLeftSouth1: "--",
      temperatureSaddleLeftSouth2: "--",
      temperatureSaddleLeftSouth3: "--",
      temperatureSaddleRightNorth1: "--",
      temperatureSaddleRightNorth2: "--",
      temperatureSaddleRightNorth3: "--",
      temperatureSaddleRightSouth1: "--",
      temperatureSaddleRightSouth2: "--",
      temperatureSaddleRightSouth3: "--",

      temperature1E0: "--",
      temperature1E1: "--",
      temperature1E4: "--",
      temperature1E5: "--",
      temperature1E8: "--",
      temperature1E9: "--",
      temperature1W0: "--",
      temperature1W1: "--",
      temperature1W4: "--",
      temperature1W5: "--",
      temperature1W8: "--",
      temperature1W9: "--",
      temperature2E0: "--",
      temperature2E1: "--",
      temperature2E4: "--",
      temperature2E5: "--",
      temperature2E8: "--",
      temperature2E9: "--",
      temperature2W0: "--",
      temperature2W1: "--",
      temperature2W4: "--",
      temperature2W5: "--",
      temperature2W8: "--",
      temperature2W9: "--",
      temperature3E1: "--",
      temperature3E3: "--",
      temperature3E5: "--",
      temperature3W1: "--",
      temperature3W3: "--",
      temperature3W5: "--",
      temperature3E0: "--",
      temperature3E2: "--",
      temperature3E4: "--",
      temperature3W0: "--",
      temperature3W2: "--",
      temperature3W4: "--",

      pressure1E0: "--",
      pressure1E1: "--",
      pressure1E4: "--",
      pressure1E5: "--",
      pressure1E8: "--",
      pressure1E9: "--",
      pressure1W0: "--",
      pressure1W1: "--",
      pressure1W4: "--",
      pressure1W5: "--",
      pressure1W8: "--",
      pressure1W9: "--",
      pressure2E0: "--",
      pressure2E1: "--",
      pressure2E4: "--",
      pressure2E5: "--",
      pressure2E8: "--",
      pressure2E9: "--",
      pressure2W0: "--",
      pressure2W1: "--",
      pressure2W4: "--",
      pressure2W5: "--",
      pressure2W8: "--",
      pressure2W9: "--",
      pressure3E1: "--",
      pressure3E3: "--",
      pressure3E5: "--",
      pressure3W1: "--",
      pressure3W3: "--",
      pressure3W5: "--",
      pressure3E0: "--",
      pressure3E2: "--",
      pressure3E4: "--",
      pressure3W0: "--",
      pressure3W2: "--",
      pressure3W4: "--",

      flow1E0: "--",
      flow1E1: "--",
      flow1E4: "--",
      flow1E5: "--",
      flow1E8: "--",
      flow1E9: "--",
      flow1W0: "--",
      flow1W1: "--",
      flow1W4: "--",
      flow1W5: "--",
      flow1W8: "--",
      flow1W9: "--",
      flow2E0: "--",
      flow2E1: "--",
      flow2E4: "--",
      flow2E5: "--",
      flow2E8: "--",
      flow2E9: "--",
      flow2W0: "--",
      flow2W1: "--",
      flow2W4: "--",
      flow2W5: "--",
      flow2W8: "--",
      flow2W9: "--",
      flow3E1: "--",
      flow3E3: "--",
      flow3E5: "--",
      flow3W1: "--",
      flow3W3: "--",
      flow3W5: "--",
      flow3E0: "--",
      flow3E2: "--",
      flow3E4: "--",
      flow3W0: "--",
      flow3W2: "--",
      flow3W4: "--",

      //abs humidity
      absHumidity1E0: "--",
      absHumidity1E4: "--",
      absHumidity1E8: "--",
      absHumidity1W8: "--",
      absHumidity1W4: "--",
      absHumidity1W0: "--",
      absHumidity1E1: "--",
      absHumidity1E5: "--",
      absHumidity1E9: "--",
      absHumidity1W9: "--",
      absHumidity1W5: "--",
      absHumidity1W1: "--",
      absHumidity2W0: "--",
      absHumidity2E0: "--",
      absHumidity2E4: "--",
      absHumidity2E8: "--",
      absHumidity2W8: "--",
      absHumidity2W4: "--",
      absHumidity2E1: "--",
      absHumidity2E5: "--",
      absHumidity2E9: "--",
      absHumidity2W9: "--",
      absHumidity2W5: "--",
      absHumidity2W1: "--",
      absHumidity3E0: "--",
      absHumidity3E2: "--",
      absHumidity3E4: "--",
      absHumidity3W0: "--",
      absHumidity3W2: "--",
      absHumidity3W4: "--",
      absHumidity3E5: "--",
      absHumidity3E3: "--",
      absHumidity3E1: "--",
      absHumidity3W1: "--",
      absHumidity3W3: "--",
      absHumidity3W5: "--",

      absHumidityAnchorLeftNorth: "--",
      absHumidityAnchorLeftSouth: "--",
      absHumidityAnchorRightNorth: "--",
      absHumidityAnchorRightSouth: "--",
      absHumiditySaddleLeftNorth1: "--",
      absHumiditySaddleLeftNorth2: "--",
      absHumiditySaddleLeftNorth3: "--",
      absHumiditySaddleLeftSouth1: "--",
      absHumiditySaddleLeftSouth2: "--",
      absHumiditySaddleLeftSouth3: "--",
      absHumiditySaddleRightNorth1: "--",
      absHumiditySaddleRightNorth2: "--",
      absHumiditySaddleRightNorth3: "--",
      absHumiditySaddleRightSouth1: "--",
      absHumiditySaddleRightSouth2: "--",
      absHumiditySaddleRightSouth3: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierMiddle: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierMiddle: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorDehumidifierLeft: "--",
      errorDehumidifierMiddle: "--",
      errorDehumidifierRight: "--",
      errorAnchorLeftNorth: "--",
      errorAnchorLeftSouth: "--",
      errorAnchorRightNorth: "--",
      errorAnchorRightSouth: "--",
      errorSaddleLeftNorth: "--",
      errorSaddleLeftSouth: "--",
      errorSaddleRightNorth: "--",
      errorSaddleRightSouth: "--",

      error1E0: "--",
      error1E1: "--",
      error1E4: "--",
      error1E5: "--",
      error1E8: "--",
      error1E9: "--",
      error1W0: "--",
      error1W1: "--",
      error1W4: "--",
      error1W5: "--",
      error1W8: "--",
      error1W9: "--",
      error2E0: "--",
      error2E1: "--",
      error2E4: "--",
      error2E5: "--",
      error2E8: "--",
      error2E9: "--",
      error2W0: "--",
      error2W1: "--",
      error2W4: "--",
      error2W5: "--",
      error2W8: "--",
      error2W9: "--",
      error3E1: "--",
      error3E3: "--",
      error3E5: "--",
      error3W1: "--",
      error3W3: "--",
      error3W5: "--",
      error3E0: "--",
      error3E2: "--",
      error3E4: "--",
      error3W0: "--",
      error3W2: "--",
      error3W4: "--",

      //running class
      runningClassLeft: "--",
      runningClassMiddle: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierMiddle: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxAnchorLeftNorth: "--",
      humidityAllowedMaxAnchorLeftSouth: "--",
      humidityAllowedMaxAnchorRightNorth: "--",
      humidityAllowedMaxAnchorRightSouth: "--",
      humidityAllowedMaxSaddleLeftNorth1: "--",
      humidityAllowedMaxSaddleLeftNorth2: "--",
      humidityAllowedMaxSaddleLeftNorth3: "--",
      humidityAllowedMaxSaddleLeftSouth1: "--",
      humidityAllowedMaxSaddleLeftSouth2: "--",
      humidityAllowedMaxSaddleLeftSouth3: "--",
      humidityAllowedMaxSaddleRightNorth1: "--",
      humidityAllowedMaxSaddleRightNorth2: "--",
      humidityAllowedMaxSaddleRightNorth3: "--",
      humidityAllowedMaxSaddleRightSouth1: "--",
      humidityAllowedMaxSaddleRightSouth2: "--",
      humidityAllowedMaxSaddleRightSouth3: "--",

      humidityAllowedMax1E0: "--",
      humidityAllowedMax1E1: "--",
      humidityAllowedMax1E4: "--",
      humidityAllowedMax1E5: "--",
      humidityAllowedMax1E8: "--",
      humidityAllowedMax1E9: "--",
      humidityAllowedMax1W0: "--",
      humidityAllowedMax1W1: "--",
      humidityAllowedMax1W4: "--",
      humidityAllowedMax1W5: "--",
      humidityAllowedMax1W8: "--",
      humidityAllowedMax1W9: "--",
      humidityAllowedMax2E0: "--",
      humidityAllowedMax2E1: "--",
      humidityAllowedMax2E4: "--",
      humidityAllowedMax2E5: "--",
      humidityAllowedMax2E8: "--",
      humidityAllowedMax2E9: "--",
      humidityAllowedMax2W0: "--",
      humidityAllowedMax2W1: "--",
      humidityAllowedMax2W4: "--",
      humidityAllowedMax2W5: "--",
      humidityAllowedMax2W8: "--",
      humidityAllowedMax2W9: "--",
      humidityAllowedMax3E1: "--",
      humidityAllowedMax3E3: "--",
      humidityAllowedMax3E5: "--",
      humidityAllowedMax3W1: "--",
      humidityAllowedMax3W3: "--",
      humidityAllowedMax3W5: "--",
      humidityAllowedMax3E0: "--",
      humidityAllowedMax3E2: "--",
      humidityAllowedMax3E4: "--",
      humidityAllowedMax3W0: "--",
      humidityAllowedMax3W2: "--",
      humidityAllowedMax3W4: "--",

      //humidity tooltip error
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierMiddle: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorAnchorLeftNorth: "--",
      humidityTooltipErrorAnchorLeftSouth: "--",
      humidityTooltipErrorAnchorRightNorth: "--",
      humidityTooltipErrorAnchorRightSouth: "--",
      humidityTooltipErrorSaddleLeftNorth1: "--",
      humidityTooltipErrorSaddleLeftNorth2: "--",
      humidityTooltipErrorSaddleLeftNorth3: "--",
      humidityTooltipErrorSaddleLeftSouth1: "--",
      humidityTooltipErrorSaddleLeftSouth2: "--",
      humidityTooltipErrorSaddleLeftSouth3: "--",
      humidityTooltipErrorSaddleRightNorth1: "--",
      humidityTooltipErrorSaddleRightNorth2: "--",
      humidityTooltipErrorSaddleRightNorth3: "--",
      humidityTooltipErrorSaddleRightSouth1: "--",
      humidityTooltipErrorSaddleRightSouth2: "--",
      humidityTooltipErrorSaddleRightSouth3: "--",

      humidityTooltipError1E0: "--",
      humidityTooltipError1E1: "--",
      humidityTooltipError1E4: "--",
      humidityTooltipError1E5: "--",
      humidityTooltipError1E8: "--",
      humidityTooltipError1E9: "--",
      humidityTooltipError1W0: "--",
      humidityTooltipError1W1: "--",
      humidityTooltipError1W4: "--",
      humidityTooltipError1W5: "--",
      humidityTooltipError1W8: "--",
      humidityTooltipError1W9: "--",
      humidityTooltipError2E0: "--",
      humidityTooltipError2E1: "--",
      humidityTooltipError2E4: "--",
      humidityTooltipError2E5: "--",
      humidityTooltipError2E8: "--",
      humidityTooltipError2E9: "--",
      humidityTooltipError2W0: "--",
      humidityTooltipError2W1: "--",
      humidityTooltipError2W4: "--",
      humidityTooltipError2W5: "--",
      humidityTooltipError2W8: "--",
      humidityTooltipError2W9: "--",
      humidityTooltipError3E1: "--",
      humidityTooltipError3E3: "--",
      humidityTooltipError3E5: "--",
      humidityTooltipError3W1: "--",
      humidityTooltipError3W3: "--",
      humidityTooltipError3W5: "--",
      humidityTooltipError3E0: "--",
      humidityTooltipError3E2: "--",
      humidityTooltipError3E4: "--",
      humidityTooltipError3W0: "--",
      humidityTooltipError3W2: "--",
      humidityTooltipError3W4: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityDehumidifierLeft: "2715a505-3bc1-4586-be8c-167546d1000b",
        humidityDehumidifierMiddle: "8d58cb94-f773-47ce-bc0f-76df7f3e5357",
        humidityDehumidifierRight: "f78c3416-1a7e-4263-a69e-efba1d20f909",
        humidityAnchorLeftNorth: "b6c58427-687b-4041-a01a-721fbcb07a07",
        humidityAnchorLeftSouth: "5906e89a-bd87-401e-ab63-5b9de81f8d98",
        humidityAnchorRightNorth: "a2a8ff2a-03ba-421b-87b4-cefceaa40bb8",
        humidityAnchorRightSouth: "d1969534-be6e-4679-98c6-59e716aa847a",
        humiditySaddleLeftNorth1: "e9299725-657e-4b02-9eb0-6eda5f27b2f7",
        humiditySaddleLeftNorth2: "7ce782c1-bb16-4da6-8b79-81ac1afc1363",
        humiditySaddleLeftNorth3: "db1574c1-049d-4af0-bde4-215eb8f31865",
        humiditySaddleLeftSouth1: "89b01dbb-e715-4412-ab94-61b94ffe0703",
        humiditySaddleLeftSouth2: "25b0c55c-7c52-4c30-aae3-a2be072962d1",
        humiditySaddleLeftSouth3: "dfdc9e93-96df-4f09-8397-caacb8c75440",
        humiditySaddleRightNorth1: "665dc765-34a3-4574-91b3-f97d94ea3210",
        humiditySaddleRightNorth2: "eec90c4d-ca9c-4e03-a3b8-c636beff4284",
        humiditySaddleRightNorth3: "10b97c34-a592-4a64-9c59-979458ca3fb1",
        humiditySaddleRightSouth1: "18c4ed78-2ab5-4782-be36-f451f57c8172",
        humiditySaddleRightSouth2: "b48f0d79-4475-40cb-8f3d-dd30388792e0",
        humiditySaddleRightSouth3: "26cac8e1-c64d-47b0-865a-06d1de4b3e7a",

        temperatureDehumidifierLeft: "f78ce28b-57db-4f47-83d7-b9b7bcd97c40",
        temperatureDehumidifierMiddle: "44c1ad61-cd81-4f40-82ab-0a2e3a6c0952",
        temperatureDehumidifierRight: "50c9c234-a076-4b9a-8271-3e3aa5affb4f",
        temperatureAnchorLeftNorth: "931bb531-3c2a-4b40-91a1-9900a28081ff",
        temperatureAnchorLeftSouth: "0c847754-63c7-4b2b-a27c-f941f26971d7",
        temperatureAnchorRightNorth: "b9047b2d-c0ad-4705-a9fe-8a79012c7a5c",
        temperatureAnchorRightSouth: "1f5e1060-0fe3-48c9-b1a5-06750847f34d",
        temperatureSaddleLeftNorth1: "836cb354-43fa-471a-b6c4-f88e954f2c76",
        temperatureSaddleLeftNorth2: "9e72628a-f38d-402b-956d-d55ec46e3b7f",
        temperatureSaddleLeftNorth3: "8fac5a6e-2e3d-439d-8841-15d7434205b6",
        temperatureSaddleLeftSouth1: "2827725b-c107-43ad-b209-a89f586f8788",
        temperatureSaddleLeftSouth2: "b5e2fcd0-27cc-4196-8d79-b30274cb6bc4",
        temperatureSaddleLeftSouth3: "ec93834a-7121-49fe-99c1-27d3e6ab1801",
        temperatureSaddleRightNorth1: "ffee82c3-03b1-47df-a1e3-9e3cf60e3d14",
        temperatureSaddleRightNorth2: "d718b61f-1b7b-435d-af10-3ec926cc246e",
        temperatureSaddleRightNorth3: "7f452338-a59a-453b-8afd-e962f9591493",
        temperatureSaddleRightSouth1: "e5c25f9e-878d-4c93-abba-0dbd4de1a02a",
        temperatureSaddleRightSouth2: "c016c088-7b8a-45e6-8230-b39c539df9eb",
        temperatureSaddleRightSouth3: "8bfb9886-53b0-4622-b990-e65a5f6f99a9",

        humidity2W0: "3e742db9-a6b7-42b6-8bd1-1657cde1883f",
        humidity1E0: "27349ec3-b8e8-47b4-8e3e-400bfac50781",
        humidity1E4: "6e712a8c-03d6-423d-bd67-0a84a39a276b",
        humidity1E8: "48402187-783e-47ee-8ac8-86d5e9e1a1f3",
        humidity1W8: "c4324a32-53fd-4c0c-94bb-cc008041932a",
        humidity1W4: "d1f39d4e-0285-4407-8927-136585e6879d",
        humidity1W0: "566240e8-8142-4147-83ae-4a10588d4145",
        humidity2E0: "5b1a0382-b980-4975-9488-b3f1baa0c133",
        humidity2E4: "6eed8cab-277d-42de-b116-93fe15d4a78b",
        humidity2E8: "2ccb84c7-b380-4db9-ac88-c049b13d6873",
        humidity2W8: "d2f77e54-cddc-416b-94c5-e69c44f04341",
        humidity2W4: "ece3385f-46c4-4551-aa0e-44f961e0b669",
        humidity1E1: "e03cb916-f8f6-4215-a3db-5e5a507faad4",
        humidity1E5: "7393f20c-805a-46ea-95d3-ffa3c648b700",
        humidity1E9: "9e10430f-5f6b-4bc4-800f-bc11c7bbbcd7",
        humidity1W9: "364b9c7c-d6ac-4610-ba57-b034f00e4dd4",
        humidity1W5: "aeb69cac-38cf-466a-bb23-9549aa935bb4",
        humidity1W1: "c8e63109-1213-41d6-b7a2-9d22abff8aa3",
        humidity3E5: "b0e614ba-e09a-4e96-b248-ad3443269e5b",
        humidity3E3: "c8d51a4c-f322-4dee-864f-77f36028f4bd",
        humidity3E1: "aedd09b2-00ec-49b9-b51d-0583b4638279",
        humidity3W1: "96b1bd30-4579-4f8d-8f3b-a27f4c802778",
        humidity3W3: "9bcf91ef-32fe-443c-80b1-0057a35faeb0",
        humidity3W5: "3e529bf1-444f-4a96-adfb-90972cba1410",
        humidity2E1: "3919cc87-e1c0-40e5-a7fa-fc37dcf210d0",
        humidity2E5: "533da7cf-f207-4de5-a561-d7971c13f0db",
        humidity2E9: "adcf5195-9ca3-4d1f-a2bd-1704bdd6f2f9",
        humidity2W9: "658d055e-f7ae-488e-b660-94cc7983bc39",
        humidity2W5: "1f307bd5-79b8-40f6-8c68-511312a38529",
        humidity2W1: "0216aeaf-2ea7-4577-aad3-d76595ce6229",
        humidity3E0: "99f6a12a-d29d-4590-9cff-8c8d8f5c9ba7",
        humidity3E2: "5d4a90ba-8d40-44ac-aff8-4fac97c04c38",
        humidity3E4: "81196f58-6694-439c-8f0c-dfe677adddd1",
        humidity3W0: "37f0ba3f-ae2b-425c-a72f-1a09e1dd1b91",
        humidity3W2: "20611bbf-e75b-4d78-8878-82428a7370ef",
        humidity3W4: "37b2f100-1b31-4811-afc9-4969d2d5b61e",

        temperature2W0: "4a10add7-3140-4571-bb45-811103fb40f9",
        temperature1E0: "5335982c-b94e-4540-9e99-dbb21ae7ea73",
        temperature1E4: "227f2c2d-bb58-4bb4-8fe6-4cae1081a83b",
        temperature1E8: "19c0578f-97bd-4464-ace0-087a88b9f929",
        temperature1W8: "f0cec6e5-a11b-4c3c-982e-f7e91c1d94f4",
        temperature1W4: "594e97aa-2463-413b-a4a8-de6e2ba1cb14",
        temperature1W0: "e0eb6560-33c7-498b-a256-bd98b817df48",
        temperature2E0: "80275220-423d-45fc-83c9-70d15877675a",
        temperature2E4: "40081f38-5f3d-4157-8e8d-4042d0e0069b",
        temperature2E8: "343d20df-a29e-469d-8a7c-5919beac2782",
        temperature2W8: "e25d624b-9825-4b22-bda2-710868f7f039",
        temperature2W4: "d990b7c8-5c7b-4fc6-aa6e-060f1a4b2c22",
        temperature1E1: "dda44eb2-d1ff-49a8-8aa7-fcd74d2050d9",
        temperature1E5: "fe0311a0-a044-4032-96b2-d88312159689",
        temperature1E9: "b6611acd-24aa-4a67-a62d-0cda3963e0e3",
        temperature1W9: "7832c6e3-5198-4723-9e07-bbc26f4d956d",
        temperature1W5: "90cf4329-6062-486e-ad11-8b8a9128b16a",
        temperature1W1: "ceb3451f-4af7-49ed-8e3b-4cd4369e887e",
        temperature3E5: "a07a2a27-d25d-4d0d-8214-347e9deff02c",
        temperature3E3: "c7fa4b8b-bb45-4949-a4f9-5f278d86a0b8",
        temperature3E1: "f3d86061-fd54-46e3-b514-4a699a4d61fb",
        temperature3W1: "c1837b89-3cf0-4bcb-bb31-6b24afa3c6fa",
        temperature3W3: "0a0f1344-bfa5-4895-9a20-314cc5c6eb9f",
        temperature3W5: "c73425aa-660e-467c-8ef5-0fd3fbc491c0",
        temperature2E1: "c20dd1db-455c-4091-9c50-d82579ec8c83",
        temperature2E5: "1fa209f6-8a4d-4336-9057-71766d061d69",
        temperature2E9: "937fb11a-495b-4276-ad6d-6f366a8f3857",
        temperature2W9: "c4cadbc7-d7d7-41b5-84aa-f0f1e4db9327",
        temperature2W5: "a21e0c43-b3f4-473b-85f5-85738e5e6856",
        temperature2W1: "bfc334bf-9f4b-4c40-8389-252f07c05eec",
        temperature3E0: "a425d2f9-cf3b-4cf8-a65c-189bc8f2548a",
        temperature3E2: "e44134c1-105a-4924-aa73-f916438a0ca9",
        temperature3E4: "ee6364a5-b2c1-447f-ac5c-fafcd9420868",
        temperature3W0: "7ad24daf-8b97-4d73-907a-90e615772bbc",
        temperature3W2: "895fbbf7-aab3-423d-b79d-70df5207cccf",
        temperature3W4: "4b50eb8a-332d-4cb6-acde-0cbc3385925f",

        pressure2W0: "444ad835-1ad8-402b-a792-7aed764897db",
        pressure1E0: "7c868e2e-1524-417a-ae22-3fab21fa9c49",
        pressure1E4: "8309f86d-9ccf-45ff-a5b6-cb9d9ea03e00",
        pressure1E8: "cd0b81b5-59a8-4455-addc-ac2277c44667",
        pressure1W8: "ac5bfc5e-16d6-448b-bdc6-ce121d605d7e",
        pressure1W4: "af842b8a-7136-4052-a2db-9afbb23688fc",
        pressure1W0: "368d83fb-9884-46c4-b695-76d91a1a6c7a",
        pressure2E0: "697657bc-b2af-4fc0-9a93-2f2de556df83",
        pressure2E4: "bcb4c48b-cd7b-466d-a363-a82a3991692f",
        pressure2E8: "9a42babf-34e5-4d17-89ae-76f091c7f492",
        pressure2W8: "be57a3c0-804c-4ee4-a9b2-365f44516916",
        pressure2W4: "7819fc57-e44f-4b09-a96c-3a48486747a3",
        pressure1E1: "77fe75de-071c-4c16-9652-3d0964f4fe48",
        pressure1E5: "8229702a-2923-4ecb-a94b-d479e698277e",
        pressure1E9: "4a8aab93-a3d2-4ff5-9faf-1f7fb8d37377",
        pressure1W9: "3b73c0f3-234a-4e0b-9ee8-dd6e0ee75830",
        pressure1W5: "42607a96-9fe1-436a-a244-87a1dbc075c7",
        pressure1W1: "9e4f0e55-0d93-4d76-a3cc-7d1c70dcdabe",
        pressure3E5: "f905252e-17fe-464f-9b1a-bd5c31198b5d",
        pressure3E3: "83ef342b-c320-4117-bd0f-9f8002a9d486",
        pressure3E1: "b2964173-0820-4a1c-aad3-f342ce711c58",
        pressure3W1: "671295c9-bf55-4f7f-9e34-7df30b388371",
        pressure3W3: "c99c2adf-aaa9-47ef-a857-105c83048e8b",
        pressure3W5: "d9e52291-d337-4a63-9ebd-9fed40157a1f",
        pressure2E1: "6bfeead1-0b0a-4b0d-92dd-bc81809d4d52",
        pressure2E5: "74c89ece-8f73-48cf-8177-258f4b4416e8",
        pressure2E9: "4724d29d-3e48-4ab9-af33-c2cbaf25d803",
        pressure2W9: "3768e113-f311-4f17-8e59-8da6b53fb762",
        pressure2W5: "07e0e0d9-9892-4201-bd44-8b754823cb10",
        pressure2W1: "bad2a145-3e84-4905-9d81-f8580c57fe7a",
        pressure3E0: "20d2a44c-389c-4aa4-bcb2-992b18ce5934",
        pressure3E2: "7a3defc3-144a-40b5-b916-0493c52e6119",
        pressure3E4: "e38b1292-dc92-42a7-ac8c-4b46bcd0fac1",
        pressure3W0: "78f27558-9c23-4d23-b247-65fa375ff54d",
        pressure3W2: "c2983f8d-ab6d-4f0e-9048-ab7ef71993c2",
        pressure3W4: "4f839b31-e7bd-47e0-aaec-66c0dc4a3c1f",

        flow2W0: "0d9c9b0b-51ff-4665-9a6e-2445f29f2a22",
        flow1E0: "12ba78bf-af8b-47ae-b2ca-98906157b597",
        flow1E4: "629857ff-b878-4622-a9f9-cbf1683f34f2",
        flow1E8: "9f5f5c63-1312-4a97-98eb-f43bf53775c5",
        flow1W8: "c83cf703-c21d-4eed-bca8-b881653f17dd",
        flow1W4: "1757acde-6fbd-4896-806d-8b980974f971",
        flow1W0: "6d9c1d8a-b6cb-42bc-896d-9c24c7a6029c",
        flow2E0: "f3df5ad8-4b20-4b34-8efe-f2cd24fad0c9",
        flow2E4: "b2a07241-60d1-40ab-b8a5-56ddd581eec6",
        flow2E8: "e7c736e1-9ae7-4854-8f80-64fd36bac5d4",
        flow2W8: "ade90029-56bc-4f47-b389-cc0fd39c6123",
        flow2W4: "74e55cdb-3b76-4caf-9332-aef6a4e817e1",
        flow1E1: "5fe6273d-1bde-40cc-ad5e-7d0ae3532ccb",
        flow1E5: "dc2ccc2e-0fc3-4ef2-9117-08f168af62a5",
        flow1E9: "7e4279f2-4335-4804-b92b-5226e51c36a0",
        flow1W9: "aa4768fb-6275-4d17-a613-3b5b318a3d37",
        flow1W5: "7b625560-138a-4b53-b054-914423ec7d20",
        flow1W1: "5f241831-27fd-4eaf-ac62-6a0c41907732",
        flow3E5: "c07ef1af-a276-4177-ab34-14b02383615f",
        flow3E3: "e37bf611-e09d-4906-a8af-005e4a9feb32",
        flow3E1: "a310a9fd-bf02-4a09-a1db-1465fd36180d",
        flow3W1: "bc948621-44e8-48be-951b-41e1399f1c4d",
        flow3W3: "adb3aafb-9f38-4684-b4e5-9b4d886b1817",
        flow3W5: "aded93a4-d263-4799-a63b-d7fed66a7ee0",
        flow2E1: "025fe7ec-b8cf-4fc9-8da0-7a2aedba29cf",
        flow2E5: "4706e6b2-6119-4470-bbf1-1eb5abe87ab5",
        flow2E9: "a335515e-232f-4bcd-8899-30d11df058e3",
        flow2W9: "bd8f7e4e-bcf9-4fa1-9851-6ef267a38633",
        flow2W5: "8fe02d7c-75fa-4587-bf02-611b5bbb5838",
        flow2W1: "4766f710-cdd6-48c2-8891-5ec183e577a6",
        flow3E0: "e5cf017d-f8f8-4bc6-a179-719fd138bbd1",
        flow3E2: "b2860334-6cd8-4350-9888-4d70ccbfe290",
        flow3E4: "9b25580f-3ed5-49f8-ad28-88b17a70c2e8",
        flow3W0: "1115624a-8126-4ee0-92a4-ad8f16675e2b",
        flow3W2: "4617eee7-8008-47d3-b18f-7f56eec04f6c",
        flow3W4: "b2774ea6-461a-493a-a8a8-f1cf273123ff",

        //abs humidity
        absHumidity1E0: "2352aa59-1631-496b-9df8-f302791ee1ce",
        absHumidity1E4: "86f24f4a-5c30-4b75-9c18-be6d6f8f909f",
        absHumidity1E8: "ad8e7f4c-9e04-4027-9cd9-6b8f7854fa88",
        absHumidity1W8: "d391a6d3-0b48-43c2-afb8-c1ec2ab96f22",
        absHumidity1W4: "b48e1652-aa31-4f92-8bf5-12a01a5dc214",
        absHumidity1W0: "ea9c92ea-4f64-489d-a344-edef11f9b9d3",
        absHumidity1E1: "29239b51-302a-449a-996c-0dfa5066f121",
        absHumidity1E5: "efec6df4-7e5c-40c5-80bf-16f77f9add54",
        absHumidity1E9: "d6b11b9d-845b-4f81-8cff-b2dde5b4e789",
        absHumidity1W9: "172c71ad-8fca-4348-ac4a-76a86c106ab9",
        absHumidity1W5: "a0cd9094-0649-4763-abd7-8b5eb62400c9",
        absHumidity1W1: "96c031bb-d053-40c7-96d3-46853b2e5385",
        absHumidity2W0: "d4fb9027-43c3-4783-b7a9-941a726efce6",
        absHumidity2E0: "ea2959b9-f414-4bbb-8fea-bd9bb9119394",
        absHumidity2E4: "df8acbd2-9fd9-40ca-a01e-812061243fcc",
        absHumidity2E8: "77ceb6e9-4659-44f1-8cb0-fbb7c1b97043",
        absHumidity2W8: "76973224-d75d-47a1-a905-825a74cf4b30",
        absHumidity2W4: "d49d4f1a-5ac9-4fe5-b53a-a319bca82c16",
        absHumidity2E1: "0a6c856a-073e-4db9-9020-883399edc824",
        absHumidity2E5: "ae85e94e-ea88-46e2-853c-effcbbc99030",
        absHumidity2E9: "9846f754-175f-4b53-968c-244d2fceb967",
        absHumidity2W9: "7206add8-bad4-4487-9c0a-7e97550943b5",
        absHumidity2W5: "100b6203-8c83-46ef-b637-7e3b86f802f6",
        absHumidity2W1: "ee87eff8-1d6f-495a-bf9c-5cfb287a7c9d",
        absHumidity3E0: "73edd285-08a1-41be-9141-e2d73401b7da",
        absHumidity3E2: "60a410e7-41ef-402e-8ca7-5d23ef07658e",
        absHumidity3E4: "4568095d-5e5d-4c48-8c96-c587cc113241",
        absHumidity3W0: "54fe7ebe-29a0-44c6-a91e-cc7a26c73da5",
        absHumidity3W2: "9d50318e-2663-4545-b06e-936806dedfc9",
        absHumidity3W4: "753937cf-f28f-4e24-a13f-acc406628601",
        absHumidity3E5: "ef09b46d-372e-481b-8272-d6ad6fd552fd",
        absHumidity3E3: "9e9f4572-60c3-4719-a6dd-af20edc9847c",
        absHumidity3E1: "8bf3d7f8-f5f7-4357-9449-58b8fb0b52ce",
        absHumidity3W1: "9ed395eb-c8c4-49a1-8c18-68944afe6676",
        absHumidity3W3: "9b06337d-b9cb-44e8-8f0b-ea29fb96c8b8",
        absHumidity3W5: "fde413cc-3133-4c6a-bf54-bba582108059",

        absHumidityAnchorLeftNorth: "0952b79f-414a-4301-b0e0-cb69c30e9a47",
        absHumidityAnchorLeftSouth: "c0b477b3-16c1-4e11-a700-71f63b29507d",
        absHumidityAnchorRightNorth: "1039863e-b9d1-4e80-a6dd-e99336f88ef1",
        absHumidityAnchorRightSouth: "a0d7430d-e962-4dd0-8eda-aff55384856a",
        absHumiditySaddleLeftNorth1: "f521ad91-8faa-4ead-a235-dcc090ecbcad",
        absHumiditySaddleLeftNorth2: "1aba5878-ca93-4184-8c8c-7d2a176cc059",
        absHumiditySaddleLeftNorth3: "616100ab-42fc-4480-a639-f803a547c9ec",
        absHumiditySaddleLeftSouth1: "19ac6c30-faf2-4152-b047-200ac2c3741c",
        absHumiditySaddleLeftSouth2: "ba0a067c-79cf-4f43-8c43-233d37e53d18",
        absHumiditySaddleLeftSouth3: "8967c91e-3d0e-4c01-b664-c07c5b44c683",
        absHumiditySaddleRightNorth1: "eda6ba82-5662-4e8a-a5ac-d1ede0d096f3",
        absHumiditySaddleRightNorth2: "1fd775dd-bcb3-4785-8803-43c3a128233a",
        absHumiditySaddleRightNorth3: "3499e8ed-cdd1-4c31-a5b7-9331827cafcd",
        absHumiditySaddleRightSouth1: "9160d80a-dafe-4ac8-8b20-e9c52be28260",
        absHumiditySaddleRightSouth2: "97bace24-26f3-4a48-b8a2-a9ea0aac8602",
        absHumiditySaddleRightSouth3: "f6e73bc7-da05-44b5-8052-907b167e3157",

        //running
        runningDehumidifierLeft: "bbffbc8c-5879-48e1-9491-e13ee6e92652",
        runningDehumidifierMiddle: "910a168f-9c22-405f-814f-5cb87ac29079",
        runningDehumidifierRight: "58ed1ec9-3096-46b2-8b56-eb5da3b268e7",

        //malfunction
        malfunctionDehumidifierLeft: "2618ad27-976f-471a-845d-956e3fe26c52",
        malfunctionDehumidifierMiddle: "1a7ef191-a545-41de-9e60-af7f0618ada3",
        malfunctionDehumidifierRight: "97856dae-797c-4f97-8eb4-d7d1864f7a02",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierLeft: "2715a505-3bc1-4586-be8c-167546d1000b",
        humidityAllowedMaxDehumidifierMiddle: "8d58cb94-f773-47ce-bc0f-76df7f3e5357",
        humidityAllowedMaxDehumidifierRight: "f78c3416-1a7e-4263-a69e-efba1d20f909",
        humidityAllowedMaxAnchorLeftNorth: "b6c58427-687b-4041-a01a-721fbcb07a07",
        humidityAllowedMaxAnchorLeftSouth: "5906e89a-bd87-401e-ab63-5b9de81f8d98",
        humidityAllowedMaxAnchorRightNorth: "a2a8ff2a-03ba-421b-87b4-cefceaa40bb8",
        humidityAllowedMaxAnchorRightSouth: "d1969534-be6e-4679-98c6-59e716aa847a",
        humidityAllowedMaxSaddleLeftNorth1: "e9299725-657e-4b02-9eb0-6eda5f27b2f7",
        humidityAllowedMaxSaddleLeftNorth2: "7ce782c1-bb16-4da6-8b79-81ac1afc1363",
        humidityAllowedMaxSaddleLeftNorth3: "db1574c1-049d-4af0-bde4-215eb8f31865",
        humidityAllowedMaxSaddleLeftSouth1: "89b01dbb-e715-4412-ab94-61b94ffe0703",
        humidityAllowedMaxSaddleLeftSouth2: "25b0c55c-7c52-4c30-aae3-a2be072962d1",
        humidityAllowedMaxSaddleLeftSouth3: "dfdc9e93-96df-4f09-8397-caacb8c75440",
        humidityAllowedMaxSaddleRightNorth1: "665dc765-34a3-4574-91b3-f97d94ea3210",
        humidityAllowedMaxSaddleRightNorth2: "eec90c4d-ca9c-4e03-a3b8-c636beff4284",
        humidityAllowedMaxSaddleRightNorth3: "10b97c34-a592-4a64-9c59-979458ca3fb1",
        humidityAllowedMaxSaddleRightSouth1: "18c4ed78-2ab5-4782-be36-f451f57c8172",
        humidityAllowedMaxSaddleRightSouth2: "b48f0d79-4475-40cb-8f3d-dd30388792e0",
        humidityAllowedMaxSaddleRightSouth3: "26cac8e1-c64d-47b0-865a-06d1de4b3e7a",

        humidityAllowedMax1E0: "27349ec3-b8e8-47b4-8e3e-400bfac50781",
        humidityAllowedMax1E4: "6e712a8c-03d6-423d-bd67-0a84a39a276b",
        humidityAllowedMax1E8: "48402187-783e-47ee-8ac8-86d5e9e1a1f3",
        humidityAllowedMax1W8: "c4324a32-53fd-4c0c-94bb-cc008041932a",
        humidityAllowedMax1W4: "d1f39d4e-0285-4407-8927-136585e6879d",
        humidityAllowedMax1W0: "566240e8-8142-4147-83ae-4a10588d4145",
        humidityAllowedMax2E0: "5b1a0382-b980-4975-9488-b3f1baa0c133",
        humidityAllowedMax2E4: "6eed8cab-277d-42de-b116-93fe15d4a78b",
        humidityAllowedMax2E8: "2ccb84c7-b380-4db9-ac88-c049b13d6873",
        humidityAllowedMax2W8: "d2f77e54-cddc-416b-94c5-e69c44f04341",
        humidityAllowedMax2W4: "ece3385f-46c4-4551-aa0e-44f961e0b669",
        humidityAllowedMax1E1: "e03cb916-f8f6-4215-a3db-5e5a507faad4",
        humidityAllowedMax1E5: "7393f20c-805a-46ea-95d3-ffa3c648b700",
        humidityAllowedMax1E9: "9e10430f-5f6b-4bc4-800f-bc11c7bbbcd7",
        humidityAllowedMax1W9: "364b9c7c-d6ac-4610-ba57-b034f00e4dd4",
        humidityAllowedMax1W5: "aeb69cac-38cf-466a-bb23-9549aa935bb4",
        humidityAllowedMax1W1: "c8e63109-1213-41d6-b7a2-9d22abff8aa3",
        humidityAllowedMax3E5: "b0e614ba-e09a-4e96-b248-ad3443269e5b",
        humidityAllowedMax3E3: "c8d51a4c-f322-4dee-864f-77f36028f4bd",
        humidityAllowedMax3E1: "aedd09b2-00ec-49b9-b51d-0583b4638279",
        humidityAllowedMax3W1: "96b1bd30-4579-4f8d-8f3b-a27f4c802778",
        humidityAllowedMax3W3: "9bcf91ef-32fe-443c-80b1-0057a35faeb0",
        humidityAllowedMax3W5: "3e529bf1-444f-4a96-adfb-90972cba1410",
        humidityAllowedMax2E1: "3919cc87-e1c0-40e5-a7fa-fc37dcf210d0",
        humidityAllowedMax2E5: "533da7cf-f207-4de5-a561-d7971c13f0db",
        humidityAllowedMax2E9: "adcf5195-9ca3-4d1f-a2bd-1704bdd6f2f9",
        humidityAllowedMax2W9: "658d055e-f7ae-488e-b660-94cc7983bc39",
        humidityAllowedMax2W5: "1f307bd5-79b8-40f6-8c68-511312a38529",
        humidityAllowedMax2W1: "0216aeaf-2ea7-4577-aad3-d76595ce6229",
        humidityAllowedMax3E0: "99f6a12a-d29d-4590-9cff-8c8d8f5c9ba7",
        humidityAllowedMax3E2: "5d4a90ba-8d40-44ac-aff8-4fac97c04c38",
        humidityAllowedMax3E4: "81196f58-6694-439c-8f0c-dfe677adddd1",
        humidityAllowedMax3W0: "37f0ba3f-ae2b-425c-a72f-1a09e1dd1b91",
        humidityAllowedMax3W2: "20611bbf-e75b-4d78-8878-82428a7370ef",
        humidityAllowedMax3W4: "37b2f100-1b31-4811-afc9-4969d2d5b61e",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        // humidityDehumidifierLeft: "errorDehumidifierLeft",
        // humidityDehumidifierMiddle: "errorDehumidifierMiddle",
        // humidityDehumidifierRight: "errorDehumidifierRight",
        // temperatureDehumidifierLeft: "errorDehumidifierLeft",
        // temperatureDehumidifierMiddle: "errorDehumidifierMiddle",
        // temperatureDehumidifierRight: "errorDehumidifierRight",

        humidityAnchorLeftNorth: "errorAnchorLeftNorth",
        humidityAnchorLeftSouth: "errorAnchorLeftSouth",
        humidityAnchorRightNorth: "errorAnchorRightNorth",
        humidityAnchorRightSouth: "errorAnchorRightSouth",
        humiditySaddleLeftNorth1: "errorSaddleLeftNorth",
        humiditySaddleLeftNorth2: "errorSaddleLeftNorth",
        humiditySaddleLeftNorth3: "errorSaddleLeftNorth",
        humiditySaddleLeftSouth1: "errorSaddleLeftSouth",
        humiditySaddleLeftSouth2: "errorSaddleLeftSouth",
        humiditySaddleLeftSouth3: "errorSaddleLeftSouth",
        humiditySaddleRightNorth1: "errorSaddleRightNorth",
        humiditySaddleRightNorth2: "errorSaddleRightNorth",
        humiditySaddleRightNorth3: "errorSaddleRightNorth",
        humiditySaddleRightSouth1: "errorSaddleRightSouth",
        humiditySaddleRightSouth2: "errorSaddleRightSouth",
        humiditySaddleRightSouth3: "errorSaddleRightSouth",

        temperaturerAnchorLeftNorth: "errorAnchorLeftNorth",
        temperaturerAnchorLeftSouth: "errorAnchorLeftSouth",
        temperaturerAnchorRightNorth: "errorAnchorRightNorth",
        temperaturerAnchorRightSouth: "errorAnchorRightSouth",
        temperaturerSaddleLeftNorth1: "errorSaddleLeftNorth",
        temperaturerSaddleLeftNorth2: "errorSaddleLeftNorth",
        temperaturerSaddleLeftNorth3: "errorSaddleLeftNorth",
        temperaturerSaddleLeftSouth1: "errorSaddleLeftSouth",
        temperaturerSaddleLeftSouth2: "errorSaddleLeftSouth",
        temperaturerSaddleLeftSouth3: "errorSaddleLeftSouth",
        temperaturerSaddleRightNorth1: "errorSaddleRightNorth",
        temperaturerSaddleRightNorth2: "errorSaddleRightNorth",
        temperaturerSaddleRightNorth3: "errorSaddleRightNorth",
        temperaturerSaddleRightSouth1: "errorSaddleRightSouth",
        temperaturerSaddleRightSouth2: "errorSaddleRightSouth",
        temperaturerSaddleRightSouth3: "errorSaddleRightSouth",

        humidity1E0: "error1E0",
        humidity1E1: "error1E1",
        humidity1E4: "error1E4",
        humidity1E5: "error1E5",
        humidity1E8: "error1E8",
        humidity1E9: "error1E9",
        humidity1W0: "error1W0",
        humidity1W1: "error1W1",
        humidity1W4: "error1W4",
        humidity1W5: "error1W5",
        humidity1W8: "error1W8",
        humidity1W9: "error1W9",
        humidity2E0: "error2E0",
        humidity2E1: "error2E1",
        humidity2E4: "error2E4",
        humidity2E5: "error2E5",
        humidity2E8: "error2E8",
        humidity2E9: "error2E9",
        humidity2W0: "error2W0",
        humidity2W1: "error2W1",
        humidity2W4: "error2W4",
        humidity2W5: "error2W5",
        humidity2W8: "error2W8",
        humidity2W9: "error2W9",
        humidity3E1: "error3E1",
        humidity3E3: "error3E3",
        humidity3E5: "error3E5",
        humidity3W1: "error3W1",
        humidity3W3: "error3W3",
        humidity3W5: "error3W5",
        humidity3E0: "error3E0",
        humidity3E2: "error3E2",
        humidity3E4: "error3E4",
        humidity3W0: "error3W0",
        humidity3W2: "error3W2",
        humidity3W4: "error3W4",
        temperaturer1E0: "error1E0",
        temperaturer1E1: "error1E1",
        temperaturer1E4: "error1E4",
        temperaturer1E5: "error1E5",
        temperaturer1E8: "error1E8",
        temperaturer1E9: "error1E9",
        temperaturer1W0: "error1W0",
        temperaturer1W1: "error1W1",
        temperaturer1W4: "error1W4",
        temperaturer1W5: "error1W5",
        temperaturer1W8: "error1W8",
        temperaturer1W9: "error1W9",
        temperaturer2E0: "error2E0",
        temperaturer2E1: "error2E1",
        temperaturer2E4: "error2E4",
        temperaturer2E5: "error2E5",
        temperaturer2E8: "error2E8",
        temperaturer2E9: "error2E9",
        temperaturer2W0: "error2W0",
        temperaturer2W1: "error2W1",
        temperaturer2W4: "error2W4",
        temperaturer2W5: "error2W5",
        temperaturer2W8: "error2W8",
        temperaturer2W9: "error2W9",
        temperaturer3E1: "error3E1",
        temperaturer3E3: "error3E3",
        temperaturer3E5: "error3E5",
        temperaturer3W1: "error3W1",
        temperaturer3W3: "error3W3",
        temperaturer3W5: "error3W5",
        temperaturer3E0: "error3E0",
        temperaturer3E2: "error3E2",
        temperaturer3E4: "error3E4",
        temperaturer3W0: "error3W0",
        temperaturer3W2: "error3W2",
        temperaturer3W4: "error3W4",
        pressure1E0: "error1E0",
        pressure1E1: "error1E1",
        pressure1E4: "error1E4",
        pressure1E5: "error1E5",
        pressure1E8: "error1E8",
        pressure1E9: "error1E9",
        pressure1W0: "error1W0",
        pressure1W1: "error1W1",
        pressure1W4: "error1W4",
        pressure1W5: "error1W5",
        pressure1W8: "error1W8",
        pressure1W9: "error1W9",
        pressure2E0: "error2E0",
        pressure2E1: "error2E1",
        pressure2E4: "error2E4",
        pressure2E5: "error2E5",
        pressure2E8: "error2E8",
        pressure2E9: "error2E9",
        pressure2W0: "error2W0",
        pressure2W1: "error2W1",
        pressure2W4: "error2W4",
        pressure2W5: "error2W5",
        pressure2W8: "error2W8",
        pressure2W9: "error2W9",
        pressure3E1: "error3E1",
        pressure3E3: "error3E3",
        pressure3E5: "error3E5",
        pressure3W1: "error3W1",
        pressure3W3: "error3W3",
        pressure3W5: "error3W5",
        pressure3E0: "error3E0",
        pressure3E2: "error3E2",
        pressure3E4: "error3E4",
        pressure3W0: "error3W0",
        pressure3W2: "error3W2",
        pressure3W4: "error3W4",
        flow1E0: "error1E0",
        flow1E1: "error1E1",
        flow1E4: "error1E4",
        flow1E5: "error1E5",
        flow1E8: "error1E8",
        flow1E9: "error1E9",
        flow1W0: "error1W0",
        flow1W1: "error1W1",
        flow1W4: "error1W4",
        flow1W5: "error1W5",
        flow1W8: "error1W8",
        flow1W9: "error1W9",
        flow2E0: "error2E0",
        flow2E1: "error2E1",
        flow2E4: "error2E4",
        flow2E5: "error2E5",
        flow2E8: "error2E8",
        flow2E9: "error2E9",
        flow2W0: "error2W0",
        flow2W1: "error2W1",
        flow2W4: "error2W4",
        flow2W5: "error2W5",
        flow2W8: "error2W8",
        flow2W9: "error2W9",
        flow3E1: "error3E1",
        flow3E3: "error3E3",
        flow3E5: "error3E5",
        flow3W1: "error3W1",
        flow3W3: "error3W3",
        flow3W5: "error3W5",
        flow3E0: "error3E0",
        flow3E2: "error3E2",
        flow3E4: "error3E4",
        flow3W0: "error3W0",
        flow3W2: "error3W2",
        flow3W4: "error3W4",

        //abs humidity
        absHumidity1E0: "error1E0",
        absHumidity1E4: "error1E4",
        absHumidity1E8: "error1E8",
        absHumidity1W8: "error1W8",
        absHumidity1W4: "error1W4",
        absHumidity1W0: "error1W0",
        absHumidity1E1: "error1E1",
        absHumidity1E5: "error1E5",
        absHumidity1E9: "error1E9",
        absHumidity1W9: "error1W9",
        absHumidity1W5: "error1W5",
        absHumidity1W1: "error1W1",
        absHumidity2W0: "error2W0",
        absHumidity2E0: "error2E0",
        absHumidity2E4: "error2E4",
        absHumidity2E8: "error2E8",
        absHumidity2W8: "error2W8",
        absHumidity2W4: "error2W4",
        absHumidity2E1: "error2E1",
        absHumidity2E5: "error2E5",
        absHumidity2E9: "error2E9",
        absHumidity2W9: "error2W9",
        absHumidity2W5: "error2W5",
        absHumidity2W1: "error2W1",
        absHumidity3E0: "error3E0",
        absHumidity3E2: "error3E2",
        absHumidity3E4: "error3E4",
        absHumidity3W0: "error3W0",
        absHumidity3W2: "error3W2",
        absHumidity3W4: "error3W4",
        absHumidity3E5: "error3E5",
        absHumidity3E3: "error3E3",
        absHumidity3E1: "error3E1",
        absHumidity3W1: "error3W1",
        absHumidity3W3: "error3W3",
        absHumidity3W5: "error3W5",

        absHumidityAnchorLeftNorth: "errorAnchorLeftNorth",
        absHumidityAnchorLeftSouth: "errorAnchorLeftSouth",
        absHumidityAnchorRightNorth: "errorAnchorRightNorth",
        absHumidityAnchorRightSouth: "errorAnchorRightSouth",
        absHumiditySaddleLeftNorth1: "errorSaddleLeftNorth1",
        absHumiditySaddleLeftNorth2: "errorSaddleLeftNorth2",
        absHumiditySaddleLeftNorth3: "errorSaddleLeftNorth3",
        absHumiditySaddleLeftSouth1: "errorSaddleLeftSouth1",
        absHumiditySaddleLeftSouth2: "errorSaddleLeftSouth2",
        absHumiditySaddleLeftSouth3: "errorSaddleLeftSouth3",
        absHumiditySaddleRightNorth1: "errorSaddleRightNorth1",
        absHumiditySaddleRightNorth2: "errorSaddleRightNorth2",
        absHumiditySaddleRightNorth3: "errorSaddleRightNorth3",
        absHumiditySaddleRightSouth1: "errorSaddleRightSouth1",
        absHumiditySaddleRightSouth2: "errorSaddleRightSouth2",
        absHumiditySaddleRightSouth3: "errorSaddleRightSouth3",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierMiddle: "errorDehumidifierMiddle",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierMiddle: "humidityTooltipErrorDehumidifierMiddle",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
        humidityAnchorLeftNorth: "humidityTooltipErrorAnchorLeftNorth",
        humidityAnchorLeftSouth: "humidityTooltipErrorAnchorLeftSouth",
        humidityAnchorRightNorth: "humidityTooltipErrorAnchorRightNorth",
        humidityAnchorRightSouth: "humidityTooltipErrorAnchorRightSouth",
        humiditySaddleLeftNorth1: "humidityTooltipErrorSaddleLeftNorth1",
        humiditySaddleLeftNorth2: "humidityTooltipErrorSaddleLeftNorth2",
        humiditySaddleLeftNorth3: "humidityTooltipErrorSaddleLeftNorth3",
        humiditySaddleLeftSouth1: "humidityTooltipErrorSaddleLeftSouth1",
        humiditySaddleLeftSouth2: "humidityTooltipErrorSaddleLeftSouth2",
        humiditySaddleLeftSouth3: "humidityTooltipErrorSaddleLeftSouth3",
        humiditySaddleRightNorth1: "humidityTooltipErrorSaddleRightNorth1",
        humiditySaddleRightNorth2: "humidityTooltipErrorSaddleRightNorth2",
        humiditySaddleRightNorth3: "humidityTooltipErrorSaddleRightNorth3",
        humiditySaddleRightSouth1: "humidityTooltipErrorSaddleRightSouth1",
        humiditySaddleRightSouth2: "humidityTooltipErrorSaddleRightSouth2",
        humiditySaddleRightSouth3: "humidityTooltipErrorSaddleRightSouth3",

        humidity1E0: "humidityTooltipError1E0",
        humidity1E1: "humidityTooltipError1E1",
        humidity1E4: "humidityTooltipError1E4",
        humidity1E5: "humidityTooltipError1E5",
        humidity1E8: "humidityTooltipError1E8",
        humidity1E9: "humidityTooltipError1E9",
        humidity1W0: "humidityTooltipError1W0",
        humidity1W1: "humidityTooltipError1W1",
        humidity1W4: "humidityTooltipError1W4",
        humidity1W5: "humidityTooltipError1W5",
        humidity1W8: "humidityTooltipError1W8",
        humidity1W9: "humidityTooltipError1W9",
        humidity2E0: "humidityTooltipError2E0",
        humidity2E1: "humidityTooltipError2E1",
        humidity2E4: "humidityTooltipError2E4",
        humidity2E5: "humidityTooltipError2E5",
        humidity2E8: "humidityTooltipError2E8",
        humidity2E9: "humidityTooltipError2E9",
        humidity2W0: "humidityTooltipError2W0",
        humidity2W1: "humidityTooltipError2W1",
        humidity2W4: "humidityTooltipError2W4",
        humidity2W5: "humidityTooltipError2W5",
        humidity2W8: "humidityTooltipError2W8",
        humidity2W9: "humidityTooltipError2W9",
        humidity3E1: "humidityTooltipError3E1",
        humidity3E3: "humidityTooltipError3E3",
        humidity3E5: "humidityTooltipError3E5",
        humidity3W1: "humidityTooltipError3W1",
        humidity3W3: "humidityTooltipError3W3",
        humidity3W5: "humidityTooltipError3W5",
        humidity3E0: "humidityTooltipError3E0",
        humidity3E2: "humidityTooltipError3E2",
        humidity3E4: "humidityTooltipError3E4",
        humidity3W0: "humidityTooltipError3W0",
        humidity3W2: "humidityTooltipError3W2",
        humidity3W4: "humidityTooltipError3W4",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierMiddle: "runningClassMiddle",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "9e83909e-c250-4035-a417-87bbb5c4d861",
        "c0e922a5-075e-49c8-bb8e-2b39a9e57cc9",
        "d0a4f217-9eb2-42e6-992f-cd9cf73befd1",
        "4ff8f361-e4aa-40a4-9048-90985db24a88",
        "2e241429-2eee-4cf4-bc8e-7e7ed1ee2dde",
        "167492d7-1c68-473a-a789-7d4165b60e1f",
        "7ab6a856-37cf-4735-a0fa-6dfc740cb3a8",
        "f3bf71b1-4f8f-474f-b5ec-b5acd27cea7e",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel === "" && allowedMax === "") {
        //no humidity dehumidifier
        // console.log('running flag: ' + runningFlag + ", error flag: " + errorFlag);
        if (runningFlag === null || errorFlag === null) {
          result += "数据中断";
        }

        if (runningFlag > 0) {
          result += " 除湿机运行";
        } else if (runningFlag === 0) {
          result += " 除湿机停止";
        }

        if (errorFlag > 0) {
          result += "  故障报警";
        }
      } else {
        //normal dehumidifier
        if (errorLevel.toLowerCase() !== "warning") {
          if (runningFlag > 0) {
            result += ", 除湿机运行";
          } else if (runningFlag === 0) {
            result += ", 除湿机停止";
          }
        }

        if (errorFlag > 0) {
          result += ", 故障报警";
        }
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1350px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            // border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
          clip-path: path(evenodd, "M10 0 L0 20 L20 20 Z M10 7 L6 16 L14 16 Z");
        }

        .sensor2:after {
          background: #3376c7;
          clip-path: polygon(0 0, 100% 0, 50% 100%);
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/balinghe/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 15px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          // border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            .bold {
              font-weight: 800;
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-right-pos:before {
              left: 81.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            // background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .sensor-clamp-triangle {
              width: 100%;
              height: 100%;
              background: #c7798b;
              clip-path: path(evenodd, "M8 0 L0 16 L16 16 Z M8 6 L5 13 L11 13 Z");
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            // background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .sensor-clamp-triangle {
              width: 100%;
              height: 100%;
              background: #3376c7;
              clip-path: polygon(0 0, 100% 0, 50% 100%);
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-left {
          top: 95px;
          left: 230px;
        }

        .station-block-middle {
          top: 165px;
          left: 590px;
        }

        .station-block-right {
          top: 93px;
          left: 953px;
        }

        .sta-left {
          top: 108px;
          left: 282px;

          &::before {
            bottom: 20px;
            left: -65px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -35px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-middle {
          top: 188px;
          left: 640px;

          &::before {
            bottom: 75px;
            left: -105px;
            width: 130px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -29px;
            top: -150px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right {
          top: 108px;
          left: 1005px;

          &::before {
            bottom: 25px;
            left: -60px;
            width: 40px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -42px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-anchor-left {
          top: 188px;
          left: 62px;

          &::before {
            bottom: -20px;
            left: -24px;
            width: 70px;
            transform: rotate(265deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
          }

          .state-info {
            right: -158px;
            top: 69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-anchor-right {
          top: 168px;
          left: 1100px;

          &::before {
            bottom: -20px;
            left: -16px;
            width: 50px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -20px;
            top: 79px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-saddle-left {
          top: 92px;
          left: 233px;

          &::before {
            bottom: 35px;
            left: -33px;
            width: 80px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 110px;
            left: -6px;
            width: 0px;
          }

          .state-info {
            right: -62px;
            top: -95px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-saddle-right {
          top: 88px;
          left: 956px;

          &::before {
            bottom: 35px;
            left: -33px;
            width: 80px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 110px;
            left: -6px;
            width: 0px;
          }

          .state-info {
            right: -62px;
            top: -93px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-1 {
          top: 175px;
          left: 80px;

          &::before {
            bottom: 24px;
            left: -20px;
            width: 36px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-2 {
          top: 145px;
          left: 140px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-3 {
          top: 103px;
          left: 220px;

          &::before {
            bottom: 24px;
            left: -20px;
            width: 36px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-1 {
          top: 100px;
          left: 248px;

          &::before {
            bottom: 24px;
            left: 1px;
            width: 36px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 27px;
          }

          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-2 {
          top: 126px;
          left: 325px;

          &::before {
            bottom: 48px;
            left: -38px;
            width: 100px;
            transform: rotate(95deg);
          }

          &::after {
            bottom: 97px;
            left: 16px;
          }

          .state-info {
            right: -160px;
            top: -82px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-3 {
          top: 145px;
          left: 408px;

          &::before {
            bottom: -33px;
            left: -32px;
            width: 70px;
            transform: rotate(275deg);
          }

          &::after {
            bottom: -68px;
            left: -14px;
          }

          .state-info {
            right: 26px;
            top: 84px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-4 {
          top: 158px;
          left: 506px;

          &::before {
            bottom: 15px;
            left: -0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-5 {
          top: 165px;
          left: 576px;

          &::before {
            bottom: -19px;
            left: -30px;
            width: 65px;
            transform: rotate(280deg);
          }

          &::after {
            bottom: -50px;
            left: -18px;
          }

          .state-info {
            right: 35px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-6 {
          top: 160px;
          left: 532px;

          &::before {
            bottom: 15px;
            left: 0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-6 {
          top: 160px;
          left: 642px;

          &::before {
            bottom: -9px;
            left: -4px;
            width: 22px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -68px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-5 {
          top: 165px;
          left: 612px;

          &::before {
            bottom: -19px;
            left: -20px;
            width: 65px;
            transform: rotate(260deg);
          }

          &::after {
            bottom: -50px;
            left: 18px;
          }

          .state-info {
            right: -165px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-4 {
          top: 158px;
          left: 685px;

          &::before {
            bottom: 15px;
            left: -0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-3 {
          top: 145px;
          left: 784px;

          &::before {
            bottom: -34px;
            left: -22px;
            width: 70px;
            transform: rotate(265deg);
          }

          &::after {
            bottom: -68px;
            left: 16px;
          }

          .state-info {
            right: -159px;
            top: 84px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-2 {
          top: 126px;
          left: 864px;

          &::before {
            bottom: 48px;
            left: -46px;
            width: 100px;
            transform: rotate(85deg);
          }

          &::after {
            bottom: 97px;
            left: -15px;
          }

          .state-info {
            right: 32px;
            top: -82px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-1 {
          top: 98px;
          left: 943px;

          &::before {
            bottom: 24px;
            left: -20px;
            width: 36px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -26px;
          }

          .state-info {
            right: 42px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-3 {
          top: 98px;
          left: 970px;

          &::before {
            bottom: 24px;
            left: -1px;
            width: 36px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 25px;
          }

          .state-info {
            right: -169px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-2 {
          top: 145px;
          left: 1052px;

          &::before {
            bottom: 22px;
            left: -4px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 25px;
          }

          .state-info {
            right: -168px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-1 {
          top: 160px;
          left: 1085px;

          &::before {
            bottom: 19px;
            left: 4px;
            width: 22px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 28px;
            left: 20px;
          }

          .state-info {
            right: -165px;
            top: -13px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }
      }
    }
  }
}
</style>
